import staticLists from './staticLists';
export default {
  ...staticLists,
};
